import React, { useState } from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { MailOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import {useNavigate} from "react-router-dom";
import {forgotPassword} from "../../services/auth";

const ForgotPasswordForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (values) => {
      setLoading(true);
      forgotPassword(values.email).then(res => {
          navigate(`/verify-code/${btoa(res.data.userId)}`,{
              state: {
                  email: res.data.email
              }
          });
      }).catch(error => {
          console.log("Forgot password error:", error);
          form.resetFields();
          message.error(error.response.data.error.message || 'Failed to send reset link. Please try again.');
      }).finally(() => {
          setLoading(false);
      })
  };

  return (
    <div style={{
        background: '#EFF3F6',
        flex: 1,
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    }}>
      <Card
        style={{
          width: '100%',
          maxWidth: 400,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h2 style={{ margin: 0, color: '#1890ff' }}>Forgot Password</h2>
        </div>

        <p style={{ marginBottom: '30px', color: '#666', textAlign: 'center' }}>
          Enter your email address or username and we'll send you a link to reset your password.
        </p>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="email"
            label="Email or Username"
            rules={[
              {
                required: true,
                message: 'Please enter your email address or username',
              },
              {
                type: 'string',
                message: 'Please enter a valid email address or username',
              },
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="Enter your email address"
              size="large"
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: '20px' }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              size="large"
            >
              Send Reset Link
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center' }}>
          <Button
            type="link"
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate("/signin")}
            style={{ padding: 0 }}
          >
            Back to Login
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default ForgotPasswordForm;